<template>
  <div class="material-compliance-report">
    <!-- 合规检测结论 -->
    <el-alert
      :title="conclusionTitle"
      :type="conclusionStatus"
      :description="conclusionDescription"
      show-icon
      :closable="false"
      class="conclusion-alert"
    >
    </el-alert>

    <!-- 可能性风险列表 -->
    <div class="risk-section" v-if="riskItems.length > 0">
      <div class="section-header">
        <i class="el-icon-warning"></i>
        <span class="section-title">可能性风险 ({{ riskItems.length }}项)</span>
      </div>

      <div class="risk-list">
        <el-card v-for="(item, index) in riskItems" :key="index" class="risk-item" shadow="hover">
          <div class="risk-content">
            <div class="risk-header">
              <span class="risk-rule"> {{ item.rule }}</span>
              <!-- <span class="risk-description">{{ item.detected_content }}</span> -->
            </div>
            <div class="risk-details">
              <div class="risk-time">
                <span class="label">时间段:</span>
                <span class="value">{{ item.timestamp }}</span>
              </div>
              <div class="risk-detected-content">
                <span class="label">检测内容:</span>
                <span class="value">"{{ item.detected_content }}"</span>
              </div>
              <div class="risk-preview" v-if="item.preview">
                <span class="label">预览:</span>
                <img :src="item.preview" alt="预览图" class="preview-image" />
              </div>
            </div>
            <div class="risk-actions">
              <el-button type="text" icon="el-icon-video-play" @click="playSegment(item)"> 跳转播放 </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 审核通过项目 -->
    <div class="passed-section">
      <el-card class="passed-card">
        <div slot="header" class="passed-header">
          <i class="el-icon-success"></i>
          <span class="passed-title">审核通过 ({{ passedItems.length }}项)</span>
        </div>

        <div class="passed-grid">
          <div v-for="(item, index) in passedItems" :key="index" class="passed-item">
            <i class="el-icon-check"></i>
            <span>{{ item }}</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 审核历史 -->
    <!-- <div class="history-section">
      <div class="section-header">
        <span class="section-title">审核历史</span>
      </div>

      <div class="history-list">
        <div v-for="(item, index) in historyItems" :key="index" class="history-item">
          <div class="history-time">{{ item.timestamp }}</div>
          <div class="history-content">{{ item.content }}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { parseTimeRange } from '@/views/material/script/utils'
// eslint-disable-next-line
const props = defineProps({
  form: {
    type: Object,
    default: () => {}
  }
})
// eslint-disable-next-line
const emits = defineEmits(['update-video-currtime'])
// 风险项目数据
const riskItems = computed(() => {
  return props.form.audit_results?.potential_risks || []
})

// 通过项目数据
const passedItems = computed(() => {
  if (props.form.audit_results?.passed_items) {
    return props.form.audit_results.passed_items.map((i) => {
      return `${i}检测：通过`
    })
  }
  return []
})

// 计算属性
const conclusionTitle = computed(() => {
  return props.form.audit_results?.compliance_conclusion?.summary || ''
})
const conclusionStatus = computed(() => {
  if (props.form.overall_status === 'approved') return 'success'
  return 'warning'
})

const conclusionDescription = computed(() => {
  return props.form.audit_results?.compliance_conclusion?.message || ''
})

// 方法
const playSegment = (item) => {
  const { start, end } = parseTimeRange(item.timestamp)

  if (start && end) {
    // 这里应该实现跳转到视频播放的具体时间点
    emits('update-video-currtime', { startTime: start, endTime: end })
  }
}
</script>

<style scoped lang="scss">
.material-compliance-report {
  ::v-deep .conclusion-alert {
    margin-bottom: 20px;
    padding: 20px 10px;

    .el-alert__title {
      font-size: 16px;
      font-weight: 600;
    }

    .el-alert__description {
      font-size: 14px;
      margin-top: 8px;
    }
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-left: 8px;
    }

    .el-icon-warning {
      color: #e6a23c;
      font-size: 18px;
    }
  }

  .risk-section {
    margin-bottom: 24px;

    .risk-list {
      .risk-item {
        margin-bottom: 16px;

        ::v-deep .el-card__body {
          padding: 16px;
        }

        .risk-content {
          .risk-header {
            margin-bottom: 12px;

            .risk-rule {
              color: #e6a23c;
              font-weight: 600;
              margin-right: 8px;
            }

            .risk-description {
              color: #606266;
            }
          }

          .risk-details {
            margin-bottom: 12px;

            > div {
              margin-bottom: 8px;
              display: flex;
              align-items: center;

              .label {
                color: #909399;
                margin-right: 8px;
                min-width: 80px;
              }

              .value {
                color: #303133;
              }
            }

            .risk-preview {
              .preview-image {
                width: 100px;
                height: 60px;
                object-fit: cover;
                border-radius: 4px;
                border: 1px solid #dcdfe6;
                margin-left: 8px;
              }
            }
          }

          .risk-actions {
            text-align: right;

            .el-button {
              color: #409eff;
            }
          }
        }
      }
    }
  }

  .passed-section {
    margin-bottom: 24px;

    .passed-card {
      ::v-deep .el-card__header {
        background-color: #f2fff0;
        border-bottom: 1px solid #bdffb3;
        padding: 16px;

        .passed-header {
          display: flex;
          align-items: center;

          .el-icon-success {
            color: #67c23a;
            font-size: 18px;
            margin-right: 8px;
          }

          .passed-title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
          }
        }
      }

      ::v-deep .el-card__body {
        padding: 16px;
      }
    }

    .passed-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 12px;

      .passed-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        .el-icon-check {
          color: #67c23a;
          margin-right: 8px;
          font-size: 16px;
        }

        span {
          color: #303133;
          font-size: 14px;
        }
      }
    }
  }

  .history-section {
    background-color: #eff1f9;
    padding: 16px;
    border-radius: 4px;
    .history-list {
      margin-top: 16px;

      .history-item {
        display: flex;
        align-items: center;
        padding: 4px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .history-time {
          color: #909399;
          font-size: 13px;
          min-width: 120px;
          margin-right: 16px;
        }

        .history-content {
          color: #303133;
          font-size: 14px;
          flex: 1;
        }
      }
    }
  }
}
</style>
